<div class="card">
  <div class="card-body">
    <ng-container *ngTemplateOutlet="InvoiceTemplateSituationAmendment"></ng-container>
  </div>
  <div class="card-footer" fxLayout="row" fxFlex="100" fxLayoutAlign="center" fxLayoutGap="10px" *ngIf="this.invoiceDetailModel.Amendments?.length > 0">
    <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
      <ng-container *ngTemplateOutlet="InvoiceTemplateAmendmentDetailSum"></ng-container>
    </div>
  </div>
</div>

<ng-template #InvoiceTemplateSituationAmendment>
  <div fxLayout="column">
    <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px">
      <div class="card-header-detail">AVENANT :</div>
      <button mat-icon-button color="accent" (click)="addAmendment()" *ngIf="!isReadOnlyForm">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center" fxLayoutGap="10px">
      <ng-container *ngTemplateOutlet="InvoiceTemplateAmendmentDetail"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #InvoiceTemplateAmendmentDetail>
  <form [formGroup]="invoiceDetailForm" fxLayout="column" fxFlex="100" fxLayoutAlign="start">
    <ng-container formArrayName="InvoiceAmendments">
      <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
        <ng-container *ngFor="let amendmentForm of InvoiceAmendments.controls; let i = index">
          <div class="amendment-form-row" [formGroup]="amendmentForm" fxLayout="column" fxFlex="100" fxLayoutAlign="start">

            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" [ngClass]="InvoiceAmendments.length == (i+1) ? 'customWrapper' : 'customDefaultWrapper'">
              <div fxFlex="18" fxFlex.gt-sm="18">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100" *ngIf="amendmentForm.controls['AmendmentCode'].disabled">
                  <mat-label>AVENANT </mat-label>
                  <input matInput formControlName="AmendmentLabelReadOnly" type="text" readonly>
                </mat-form-field>
                <div class="dropDownStyle" *ngIf="!amendmentForm.controls['AmendmentCode'].disabled" fxFlex="100">
                  <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" floatLabel="always">
                    <mat-label>AVENANT </mat-label>
                    <input matInput formControlName="AmendmentCode" type="text" hidden>
                    <ng-multiselect-dropdown placeholder='Sélectionner' [ngClass]="{ 'is-invalid': submitted && invoiceDetailForm.errors, 'edited-color': editedDropdowns.includes('AmendmentCode')}"
                      [settings]="dropDownSettingsAvenant" [data]="dropDownDataAvenant" formControlName="AmendmentLabel" (onSelect)="onChangeAvenant(i, amendmentForm.controls.CreatedAt.value, $event)"
                      (onDeSelect)="onChangeAvenant(i, amendmentForm.controls.CreatedAt.value, null)" ngDefaultControl>
                    </ng-multiselect-dropdown>
                  </mat-form-field>
                </div>
              </div>
              <div fxFlex="8" fxFlex.gt-sm="8">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>MONTANT AVENANT HT </mat-label>
                  <input matInput formControlName="AmendmentOriginalAmountTaxExcluded" type="text" decimalFormat readonly>
                </mat-form-field>
              </div>
              <div fxFlex="8" fxFlex.gt-sm="8">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>RESTE À FACTURER HT </mat-label>
                  <input matInput formControlName="AmendmentOriginalCumulTaxExcluded" type="text" decimalFormat readonly>
                </mat-form-field>
              </div>
              <div fxFlex="22" fxFlex.gt-sm="22">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>DESCRIPTION </mat-label>
                  <input matInput formControlName="AmendmentDescription" type="text" readonly>
                </mat-form-field>
              </div>
              <div fxFlex="14" fxFlex.gt-sm="14">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>MONTANT HT </mat-label>
                  <input matInput formControlName="AmendmentAmountTaxExcluded" type="text" decimalFormat pattern="[-]?[0-9\s+]+(?:[,\.][0-9]{0,2})?" step="0.01"
                    (change)="calculatedVatForAmendment(i, amendmentForm)">
                </mat-form-field>
              </div>
              <div fxFlex="14" fxFlex.gt-sm="14">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>MONTANT TVA </mat-label>
                  <input matInput formControlName="AmendmentAmountVat" type="text" decimalFormat pattern="[-]?[0-9\s+]+(?:[,\.][0-9]{0,2})?" step="0.01" readonly>
                </mat-form-field>
              </div>
              <div fxFlex="14" fxFlex.gt-sm="14">
                <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
                  <mat-label>MONTANT TTC </mat-label>
                  <input matInput formControlName="AmendmentAmountTaxIncluded" type="text" decimalFormat pattern="[-]?[0-9\s+]+(?:[,\.][0-9]{0,2})?" step="0.01" readonly>
                </mat-form-field>
              </div>
              <div fxFlex="2" fxFlex.gt-sm="2">
                <button mat-icon-button color="accent" (click)="deleteAmendment(i, amendmentForm.controls.CreatedAt.value)" *ngIf="!isReadOnlyForm">
                  <mat-icon>remove_circle</mat-icon>
                </button>
              </div>
            </div>

          </div>
        </ng-container>
      </div>
    </ng-container>
  </form>
</ng-template>

<ng-template #InvoiceTemplateAmendmentDetailSum>
  <div fxLayout="row" fxFlex="100" fxLayoutAlign="start" fxLayoutGap="10px" class="no-wrapper">
    <div fxFlex="20" fxFlex.gt-sm="20" fxLayoutAlign="start center">
      <h2>TOTAL AVENANT</h2>
    </div>
    <div fxFlex="10" fxFlex.gt-sm="10">
    </div>
    <div fxFlex="26" fxFlex.gt-sm="26">
    </div>
    <div fxFlex="14" fxFlex.gt-sm="14">
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>SOMME HT </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.amendmentsSumTaxExcluded}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
          [style]="commonLibrary.getSumClass()">
      </mat-form-field>
    </div>
    <div fxFlex="14" fxFlex.gt-sm="14">
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>SOMME TVA </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.amendmentsSumVAT}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled [style]="commonLibrary.getSumClass()">
      </mat-form-field>
    </div>
    <div fxFlex="14" fxFlex.gt-sm="14">
      <mat-form-field floatLabel="always" appearance="outline" fxFlex="100" fxFlex.gt-sm="100">
        <mat-label>SOMME TTC </mat-label>
        <input matInput value="{{invoiceDetailAmountCalc.amendmentsSumTaxIncluded}}" type="text" decimalFormat pattern="[0-9\s+]+([,\.][0-9]{0,2})?" step="0.01" disabled
          [style]="commonLibrary.getSumClass()">
      </mat-form-field>
    </div>
    <div fxFlex="2" fxFlex.gt-sm="2">
    </div>
  </div>
</ng-template>